import { Link } from 'react-router-dom';
import { EGRAHMANTREE_URL, PRODUCTS } from '../config/site';

const MOSAIC = [
  { product: PRODUCTS.find((p) => p.id === 'sutramq'), href: '/products/sutramq', external: false },
  { product: PRODUCTS.find((p) => p.id === 'sutraacs'), href: '/products/sutraacs', external: false },
  { product: PRODUCTS.find((p) => p.id === 'mgopennms'), href: '/products/mgopennms', external: false },
  { product: PRODUCTS.find((p) => p.id === 'egrahmantree'), href: EGRAHMANTREE_URL, external: true },
].filter((item) => item.product);

function MosaicTile({ item }) {
  const { product, href, external } = item;
  const className = 'hero-mosaic__tile';

  const inner = (
    <>
      <div className="hero-mosaic__thumb">
        <img src={product.heroImage} alt="" loading="eager" />
      </div>
      <div className="hero-mosaic__meta">
        <span className="hero-mosaic__name">{product.name}</span>
        <span className="hero-mosaic__hint">{product.isFlagship ? 'Live · Jaipur' : 'Explore →'}</span>
      </div>
    </>
  );

  if (external) {
    return (
      <a
        href={href}
        className={className}
        style={{ '--product-accent': product.accent }}
        target="_blank"
        rel="noopener noreferrer"
      >
        {inner}
      </a>
    );
  }

  return (
    <Link to={href} className={className} style={{ '--product-accent': product.accent }}>
      {inner}
    </Link>
  );
}

export default function HeroProductMosaic() {
  return (
    <div className="hero-mosaic" aria-label="Product portfolio">
      {MOSAIC.map((item) => (
        <MosaicTile key={item.product.id} item={item} />
      ))}
    </div>
  );
}
